import { render, staticRenderFns } from "./mem_preview.vue?vue&type=template&id=4119fdb3&scoped=true&"
import script from "./mem_preview.vue?vue&type=script&lang=js&"
export * from "./mem_preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4119fdb3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4119fdb3')) {
      api.createRecord('4119fdb3', component.options)
    } else {
      api.reload('4119fdb3', component.options)
    }
    module.hot.accept("./mem_preview.vue?vue&type=template&id=4119fdb3&scoped=true&", function () {
      api.rerender('4119fdb3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/create/mem_preview/mem_preview.vue"
export default component.exports